import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getApiClient } from 'api';
import { getTournamentsById, type GetTournamentsByIdResponse } from 'api/generated';

export const fetchTournament = createAsyncThunk<GetTournamentsByIdResponse | null, string | undefined>(
  'tournaments/fetchTournament',
  async (id, { rejectWithValue }) => {
    try {
      if (id) {
        const response = await getTournamentsById({
          client: getApiClient(true),
          path: { id: Number(id) },
          throwOnError: true,
        });

        return response.data;
      }
      return null;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const tournamentSlice = createSlice({
  name: 'tournament',
  initialState: {
    error: false,
    loading: false,
    tournament: null as GetTournamentsByIdResponse | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTournament.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(fetchTournament.fulfilled, (state, action: PayloadAction<GetTournamentsByIdResponse | null>) => {
      state.loading = false;
      state.tournament = action.payload;
    });
    builder.addCase(fetchTournament.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export const tournamentReducer = tournamentSlice.reducer;
